<template>
  <div class="news">
    <div class="head-img"></div>
    <div class="news-menu">
      <div class="menu-head">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>信息平台</el-breadcrumb-item>
          <el-breadcrumb-item>{{BreadText}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="gundong">
        <ul class="menu-content">
          <li v-for="item in newsMenu" :key="item.id" :class="inRouter == item.name?'innovate-gl':''">
            <router-link :to="{name:item.name}">{{item.text}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition enter-active-class="animate__animated animate__fadeIn">
      <router-view />
    </transition>
  </div>
</template>

<script>
import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      newsMenu: [
        {
          id: 1,
          text: '科室管理系统',
          name: 'keshigl'
        },
        {
          id: 2,
          text: '水机管理系统',
          name: 'watergl'
        },
        {
          id: 3,
          text: '患者管理系统',
          name: 'huanzhegl'
        },
      ],
      inRouter: this.$router.history.current.name,
      BreadText: this.$router.history.current.meta.title || '',
    }
  },
  watch: {
    $route(to) {
      let newpath = to.path.slice(1).split('/')[1]
      this.inRouter = newpath
      let MybreadText = this.newsMenu.filter(item => {
        return item.name == newpath
      })
      this.BreadText = MybreadText[0].text
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.news {
  .head-img {
    height: 5.2632rem;
    width: 100%;
    background: url('../../assets/image/News/headpic.webp') no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 250px;
      background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/F919144F855046E9AFD26EB48725C024-6-2.jpg');
      background-size: 100% 100%;
      // background-position: 50% 0;
    }
  }
  .news-menu {
    height: 1.1789rem;
    margin: 0 0.8421rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 540px) {
      margin: 0;
      height: 56px;
    }
    // justify-content: center;
    padding: 0 0.6316rem;
    align-items: center;
    .menu-head {
      padding-right: 2.6316rem;
      width: 2.6316rem;
      font-size: 0.2105rem !important;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .el-breadcrumb {
        font-size: 0.1895rem;
      }
    }
    .gundong::-webkit-scrollbar {
      display: none;
    }
    .gundong {
      height: 100%;
      @media screen and (max-width: 540px) {
        overflow: scroll;
        overflow-y: hidden;
      }
      .menu-content {
        display: flex;
        height: 100%;
        li {
          display: flex;
          align-items: center;
          height: 100%;
          padding: 0 0.4737rem;
          font-size: 0.2105rem;
          box-sizing: border-box;
          border-bottom: 6px solid #0ca4eb00;
          @media screen and (max-width: 540px) {
            font-size: 15px;
            margin: 0 15px;
          }
          a {
            font-weight: 700;
            list-style: none;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #666666;
          }
        }
      }
    }
    // 菜单高亮
    .innovate-gl {
      a {
        color: #0ca6eb !important;
      }
      // padding: 0.4737rem 0 0.3789rem 0;
      border-bottom-color: #0ca6eb !important;
      z-index: 999;
    }
  }
  .news-menu::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    height: 6px;
    width: 100%;
    border-radius: 0.0316rem;
    background-color: #f1f1f1;
  }
}
</style>
